import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ElementRef,
  OnDestroy,
  ChangeDetectionStrategy
} from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule } from "@angular/forms";
import { RouterLink } from "@angular/router";
import { NgClass } from "@angular/common";

/**
 * Hover dropdown to pick the current element from `elementList` (shows `attributeShowed`) with text filter.
 * `allowList`/`allowNew` add list and new-element links; emits `updateCurrentElementFlag`, `dropdownFilterFlag`, `resetSearchBoxFlag` and `updateSearchActiveFlag`.
 */
@Component({
  selector: "app-navbar-top-dropdown",
  templateUrl: "./navbar-top-dropdown.component.html",
  styleUrls: ["./navbar-top-dropdown.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, FormsModule, NgClass, TranslateModule]
})
export class NavbarTopDropdownComponent implements OnDestroy {
  /***************************************************************************/
  // ANCHOR Variables
  /***************************************************************************/

  @Input() classes: string;
  @Input() selectorClasses: string;
  @Input() title: string;
  @Input() type: string;
  @Input() listLink: string;
  @Input() newLink: string;
  @Input() currentElement: any;
  @Input() elementList: any[];
  @Input() attributeShowed: string;
  @Input() allowList: boolean;
  @Input() allowNew: boolean;
  @Input() highlight: string;
  closeTimeout: ReturnType<typeof setTimeout>;
  openTimeout: ReturnType<typeof setTimeout>;
  dropdownOpenDelay: number = 500;
  dropdownCloseDelay: number = 500;

  @Output() dropdownFilterFlag = new EventEmitter<any>();
  @Output() updateCurrentElementFlag = new EventEmitter<any>();
  @Output() resetSearchBoxFlag = new EventEmitter<any>();
  @Output() updateSearchActiveFlag = new EventEmitter<string>();

  @ViewChild("elementFilter") elementFilter: ElementRef;
  @ViewChild("navbarTopDropdown") navbarTopDropdown: ElementRef;

  /***************************************************************************/
  // ANCHOR Constructor
  /***************************************************************************/

  constructor() {}

  /***************************************************************************/
  // ANCHOR Component destruction
  /***************************************************************************/

  ngOnDestroy(): void {
    clearTimeout(this.openTimeout);
    clearTimeout(this.closeTimeout);
  }

  /***************************************************************************/
  // ANCHOR Functions
  /***************************************************************************/

  // Filter flag
  dropdownFilter(filterValue: any, type: string): void {
    clearTimeout(this.closeTimeout);
    this.dropdownFilterFlag.emit({
      filterValue: filterValue,
      type: type
    });
  }

  // Current element update flag
  updateCurrentElement(element: any): void {
    this.updateCurrentElementFlag.emit(element);
  }

  // Search box reset flag
  resetSearchBox(elementFilter: any, type: string): void {
    if (elementFilter) {
      elementFilter.nativeElement.value = "";
    }
    this.resetSearchBoxFlag.emit(type);
  }

  // Focus search box
  focusInput(elementFilter: any) {
    elementFilter?.nativeElement?.focus();
  }

  // Menu visibility
  toggleVisibilityFalse(): void {
    clearTimeout(this.openTimeout);
    this.closeTimeout = setTimeout(
      () =>
        this.navbarTopDropdown.nativeElement.classList.remove(
          "navbar-top-dropdown-container-hover"
        ),
      this.dropdownCloseDelay
    );
  }

  toggleVisibilityTrue(): void {
    clearTimeout(this.closeTimeout);
    this.openTimeout = setTimeout(
      () =>
        this.navbarTopDropdown.nativeElement.classList.add("navbar-top-dropdown-container-hover"),
      this.dropdownOpenDelay
    );
    this.focusInput(this.elementFilter);
  }
}
